import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";
import PrivacySettings from "./PrivacySettings";
import WaitlistAdmin from "./WaitlistAdmin";
import MatrixRain from "./MatrixRain";

function App() {
  return (
    <Router>
      <MatrixRain />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/privacy-settings" element={<PrivacySettings />} />
        <Route path="/admin/waitlist" element={<WaitlistAdmin />} />
      </Routes>
    </Router>
  );
}

export default App;
